import React from "react";

import CloseIcon from "@mui/icons-material/Close";
import { Box, BoxProps, Button, IconButton, Stack, Typography } from "@mui/material";

const boxSx: BoxProps["sx"] = {
  position: "absolute" as "absolute",
  top: "50%",
  left: "50%",
  transform: "translate(-50%, -50%)",
  bgcolor: "white",
  borderRadius: "8px",
  minHeight: "200px",
  minWidth: "500px"
};

interface ApproveProps {
  title: string;
  description: string;
  onCancel: () => void;
  onSubmit: (value: boolean) => void;
}

export const Approve: React.FC<ApproveProps> = ({ title, description, onCancel, onSubmit }) => {
  return (
    <Box sx={boxSx}>
      <Box sx={{ background: "#fff", borderRadius: "10px 10px 0px 0px", padding: "30px 30px 0 30px" }}>
        <Stack
          direction="row"
          justifyContent="space-between"
          alignItems="center"
          sx={{ borderBottom: "1px solid  #DAE0E2", paddingBottom: "5px" }}
        >
          <span>{title}</span>
          <IconButton onClick={onCancel}>
            <CloseIcon className="icon" />
          </IconButton>
        </Stack>
      </Box>
      <Stack alignItems="stretch" sx={{ p: "20px 30px 30px 30px" }}>
        <Typography variant="body1" color="#0A3142">
          {description}
        </Typography>
        <Stack sx={{ mt: "30px" }} direction="row" justifyContent="flex-end" gap="20px">
          <Button variant="outlined" onClick={onCancel}>
            Cancel
          </Button>
          <Button variant="contained" onClick={() => onSubmit(true)}>
            Approve
          </Button>
        </Stack>
      </Stack>
    </Box>
  );
};
